import(/* webpackMode: "eager" */ "/app/apps/web/src/app/me/path-coins/page.tsx");
